<template>
  <apexchart type="donut"
             :height="size"
             :width="size"
             :options="chartOptions"
             :series="series">
  </apexchart>
</template>
<script>
/**
 * @see https://css-tricks.com/building-a-donut-chart-with-vue-and-svg/
 */
export default {
  props: {
    size: {
      type: Number,
      default: 56,
    },
    percentViewed: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {}
  },
  computed: {
    series() {
      return [
        this.percentViewed,
        100 - this.percentViewed,
      ]
    },
    chartOptions() {
      return {
        chart: {
          type: 'donut',
          width: this.size,
          height: this.size,
          sparkline: {
            enabled: true
          }
        },
        colors: [
          'turquoise',
          '#eeeeee',
        ],
        labels: [
          'Viewed',
          'Not Viewed',
        ],
        stroke: {
          width: 1
        },
        tooltip: {
          enabledOnSeries: [
            0,
          ],
          y: {
            formatter: (val) => {
              return `${val}%`;
            }
          },
          fillSeriesColor: false,
          fixed: {
            enabled: false
          },
          marker: {
            show: false,
          },
          onDatasetHover: {
            highlightDataSeries: false,
          },
        }
      };
    },
  },
}
</script>
